import { render, staticRenderFns } from "./TabNav.vue?vue&type=template&id=0874e200"
import script from "./TabNav.vue?vue&type=script&lang=js"
export * from "./TabNav.vue?vue&type=script&lang=js"
import style0 from "./TabNav.vue?vue&type=style&index=0&id=0874e200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports